module.exports = __webpack_public_path__ + "static/media/wind.6ad05b4a.jpg";